import React from "react";
import WarningIcon from "@material-ui/icons/ReportProblemOutlined";
import { Text } from "components/commons";
import locale from "localization";
import styles from "./shift-records-details-incomplete.module.scss";

const ShiftRecordsDetailsIncompleteBanner = ({ count }) => {
  if (!count) {
    return null;
  }

  return (
    <div className={styles.banner}>
      <WarningIcon className={styles.bannerIcon} />
      <div>
        <Text className={styles.bannerTitle}>{locale.cannotCloseShift}</Text>
        <Text className={styles.bannerMessage}>
          {count === 1
            ? locale.oneRequiredFieldStillNeedsToBeFilledIn
            : locale.populate(locale.requiredFieldsStillNeedToBeFilledIn, [count])}
        </Text>
      </div>
    </div>
  );
};

export default ShiftRecordsDetailsIncompleteBanner;
